import type { ENV } from './is/env';

export const USER_TOKEN = 'USER_TOKEN';

export const enum Media {
  Portrait = 'portrait', // 竖屏
  Landscape = 'landscape', // 横屏
}

export const WEBP_MINI = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';

// 非常量、全局注册用
export const flags: {
  isSupportWebp?: boolean
  env?: ENV
} = {};
